import React, { useRef, useState } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { blogImage2, blogImage4 } from '../../assets/images'
import { Link } from 'react-router-dom'
import { IconHeart, IconMessages } from '@tabler/icons-react'

export default function Timeline() {

    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef([]);

    const toggleCollapse = (id) => {
        setIsOpen((isOpen === id ? null : id));
    };

    const timlineItem = [
        {
            id: "1",
            date: "20-04-2018 - Today",
            subject: "Hello, 'Im a single div responsive timeline without media Queries!",
            sender: "Elisse Joson",
            link: "#",
            address: "San Francisco, CA",
            comment: "I'm speaking with myself, number one, because I have a very good brain and I've said a lot of things. I write the best placeholder text, and I'm the biggest developer on the web card she has is the Lorem card.",
        },
        {
            id: "2",
            date: "20-04-2018 - Today",
            subject: "Hello, 'Im a single div responsive timeline without media Queries!",
            sender: "Elisse Joson",
            link: "#",
            address: "San Francisco, CA",
            comment: "I'm speaking with myself, number one, because I have a very good brain and I've said a lot of things. I write the best placeholder text, and I'm the biggest developer on the web card she has is the Lorem card.",
            children: [
                {
                    image: blogImage4,
                },
                {
                    image: blogImage2,
                },
            ],
        },
        {
            id: "3",
            date: "20-04-2018 - Today",
            subject: "Hello, 'Im a single div responsive timeline without media Queries!",
            sender: "Elisse Joson",
            link: "#",
            address: "San Francisco, CA",
            comment: "I'm speaking with myself, number one, because I have a very good brain and I've said a lot of things. I write the best placeholder text, and I'm the biggest developer on the web card she has is the Lorem card.",
        },
    ]

    return (
        <>
            <Breadcrumb title="Timeline" path="Pages / Timeline" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                {timlineItem.map((item, key) => (
                    <div key={key} className='timeline-item md:py-30 py-20 px-20 border-l border-border relative after:absolute after:content-[""] md:after:top-30 after:top-20 after:-left-2 after:w-[15px] after:h-[15px] after:rounded-full after:border-[3px] after:bg-bg-dark'>
                        <div className='text-text-secondary mb-10'>
                            {item.date}
                        </div>
                        <div className='text-[20px]/[24px] font-medium mb-5'>
                            {item.subject}
                        </div>
                        <div className='mb-20'>
                            <Link to={item.link} className='text-blue transition-all duration-300 hover:text-blue-100'>{item.sender}</Link>&nbsp;
                            <span>{item.address}</span>
                        </div>
                        <div className='mb-20'>
                            {item.comment}
                        </div>
                        {item.children &&
                            <div className='mb-20 flex flex-wrap -m-5'>
                                {item.children.map((res, key) => (
                                    <img key={key} src={res.image} alt='timeline post' className='md:w-1/4 sm:w-1/2 p-5' />
                                ))}
                            </div>}
                        <div className='flex items-center gap-20'>
                            <button className='flex items-center gap-5 text-blue transition-all duration-300 hover:text-blue-100'>
                                <IconHeart className='w-[18px] h-[18px] stroke-[1.5]' />
                                Like
                            </button>
                            <button onClick={() => toggleCollapse(item.id)} className='flex items-center gap-5 text-blue transition-all duration-300 hover:text-blue-100'>
                                <IconMessages className='w-[18px] h-[18px] stroke-[1.5]' />
                                Comment
                            </button>
                        </div>
                        <div
                            ref={ref => contentRef.current[item.id - 1] = ref}
                            className="overflow-hidden transition-all duration-300 mt-15"
                            style={{ height: (isOpen === item.id) ? `${contentRef.current[item.id - 1]?.scrollHeight}px` : '0' }}
                        >
                            <div className='form-group flex mb-15'>
                                <textarea rows={2} placeholder='Please type what you want...' />
                            </div>
                            <button className='btn btn-primary'>
                                Submit
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}
